import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import { DefaultTokenContext } from '../../context/DefaultTokenContext';
import { SetupContext } from '../../context/SetupContext';

import { Copy, CircleAlert, ZoomIn } from 'lucide-react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import QRCodeStyling from "qr-code-styling";

import 'react-datepicker/dist/react-datepicker.css'; // DatePicker 스타일 추가

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../store';

import useSecureStorage from '../../hooks/useSecureStorage';
import SubPageHeader from '../../nav/SubPageHeader';
import i18next from 'i18next'

import IbmPlexMonoText from '../../styles/IbmPlexMonoText';
import { tgShowAlert } from '../../utils/telegramPopup';

import WebApp from '@twa-dev/sdk'

interface Asset {
	id: number
	name: string
	symbol: string
	balance: string
	icon: any
}

const emptyToken: Asset = {
	id: 0,
	name: '',
	symbol: '',
	balance: '',
	icon: ''
}

const ReceiveScreen = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const { getWalletAddress, getBlockChain } = useSecureStorage()
	const { searchNetwork} = useContext(DefaultTokenContext);
	const setupContext = useContext(SetupContext);
	const location = useLocation();
	const [token, setToken] = useState(location.state === null ? null : location.state.token);
	const [address, setAddress] = useState('')
	const [network, setNetwork] = useState('')

	// 주소 표시 토글 상태: true면 전체 주소, false면 축약 주소 표시
	const [showFullAddress, setShowFullAddress] = useState<boolean>(false);

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "ReceiveScreen", "title": (token.symbol?.toUpperCase() || '')+'  '+t('stack_header_message_01') }))
	}, [])

	useEffect(() => {
		setToken(emptyToken)
		if (location.state) {
			setToken(location.state.token);
		}
	}, [location.state]);

	useEffect(() => {
		const fetchAddress = async () => {
			const walletAddress = await getWalletAddress()
			const network = await getBlockChain()
			console.log(`walletAddress : ${walletAddress}`)
			console.log(`network : ${network}`)
			setAddress(walletAddress)

			// defaultToken context 에서 네크워크 정보 검색
			const networkInfo = await searchNetwork(network)
			console.log(`newNetworkInfo : ${networkInfo}`)

			let qrIconImge = ''
			if(networkInfo && networkInfo?.icon) {
				qrIconImge = networkInfo.icon
				setNetwork(network)
			}

			if (walletAddress && qrCodeRef.current) {
				qrCode.update({ data: walletAddress, image: qrIconImge });
				qrCode.append(qrCodeRef.current);
			}
		}
		fetchAddress()
	}, [])

	// qrcode styling
	const qrCodeRef = useRef<HTMLDivElement>(null);
	const qrCode = new QRCodeStyling({
		width: 200,
		height: 200,
		type: 'svg',
		data: "",
		image: "",
		imageOptions: {
			crossOrigin: "anonymous",
			margin: 5
		},
		dotsOptions: {
			color: theme.qr_img_fill_01,
		},
	});

	const copyToClipboard = () => {
		console.log(`copyToClipboard address : ${address}`)
		if (address) {
			navigator.clipboard.writeText(address)
				.then(() => {
					tgShowAlert(i18next.t('template_receive_screen_message_01'));
				})
				.catch(err => {
					console.error('클립보드 복사 실패:', err);
				});
		}
	}

	const shareAddress = () => {
		const envShareUrl = setupContext.commonInfo?.telegram_miniapp_url || '';

		if(null != envShareUrl && '' !== envShareUrl) {
			const shareText = encodeURIComponent(i18next.t('see_more_screen_message_10'));
			const shareUrl = encodeURIComponent(envShareUrl);
			const url = `https://t.me/share/url?text=${shareText}&url=${shareUrl}`;
			console.log(`handleShare WebApp.openTelegramLink : ${url}`)
	
			try {
				WebApp.openTelegramLink(url);
			} catch (error) {
				console.log(`Error openTelegramLink`, error)
			}
		}
	}

	// ▼▼▼ (추가) 지갑 주소 표시함수 (showFullAddress 상태에 따라 표시)
	const displayedAddress = showFullAddress
    ? address
    : address
		? `${address.slice(0, 6)}....${address.slice(-6)}`
		: '';

	const styles = {
		container: {
			backgroundColor: theme.background_03,
			padding: "60px 24px 0",
		} as React.CSSProperties,
		tokenHeader: {
			fontSize: 18,
			textAlign: 'center',
			color: theme.text_01,
			marginBottom: 10
		} as React.CSSProperties,
		tokenSubHeader: {
			fontSize: 15,
			textAlign: 'center',
			color: theme.text_01
		} as React.CSSProperties,
		qrContainer: {
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			marginBottom: 35,
			marginTop: 35,
			border: `8px solid ${theme.border_02}`,
			width: 200,
			alignSelf: 'center',
			borderRadius: 10,
			height: 200
		} as React.CSSProperties,
		addressLabel: {
			fontSize: 12,
			textAlign: 'left',
			marginBottom: 8,
			color: theme.text_03
		} as React.CSSProperties,
		addressContainer: {
			marginBottom: 27,
			wordBreak: "break-word"
		} as React.CSSProperties,
		address: {
			fontSize: 16,
			textAlign: 'left',
			color: theme.text_01
		} as React.CSSProperties,
		noticeContainer: {
			marginTop: 37
		} as React.CSSProperties,
		noticeHeaderContainer: {
			display: "flex",
			alignItems: 'center',
			marginBottom: 8
		} as React.CSSProperties,
		noticeHeader: {
			fontSize: 15,
			color: theme.text_01
		} as React.CSSProperties,
		bulletContainer: {
			display: "flex",
			alignItems: 'flex-start'
		} as React.CSSProperties,
		bulletPoint: {
			fontSize: 18,
			color: theme.text_06
		} as React.CSSProperties,
		noticeText: {
			flex: 1,
			fontSize: 14,
			color: theme.text_06,
			marginLeft: 5,
		} as React.CSSProperties,
		buttonShare: {
			width: "100%",
			padding: 18,
			marginTop: 14,
			borderRadius: 10,
			alignItems: 'center',
			display: "flex",
			justifyContent: 'center',
			height: 50
		} as React.CSSProperties,
		buttonTextShare: {
			color: theme.text_01,
			fontSize: 15
		} as React.CSSProperties,
		icon: {
			marginRight: 5
		} as React.CSSProperties,
		cardContainer: {
			backgroundColor: theme.background_normal,
			borderTopLeftRadius: 10,
			borderTopRightRadius: 10,
			padding: "24px 12px",
			border: `1px solid ${theme.border_04}`,
			borderBottom: "none"
		} as React.CSSProperties,
		clipboardButton: {
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			gap: "10px",
			borderRadius: 10,
			marginTop: 10,
			border: `1px solid ${theme.border_03}`,
			height: 48,
			cursor: "pointer"
		} as React.CSSProperties,
		clipboardButtonText: {
			color: theme.text_08,
			fontSize: 14
		} as React.CSSProperties,
	}

	return (
		<>
		<SubPageHeader />
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div>
				<CustomText weight="medium" style={{ ...styles.tokenHeader, color: theme.label_strong }}>
					{token.name?.toUpperCase() || ''}{' '}
				</CustomText>
				<CustomText style={{ ...styles.tokenSubHeader, color: theme.label_strong }}>
					{i18next.t('template_receive_screen_message_06')}{' '}
					{i18next.t('template_receive_screen_message_07')}
				</CustomText>
			</div>

			{/* <div style={styles.qrContainer}>
				{address ? (
					<QRCode value={address} size={192} fgColor={theme.text_01} />
				) : (
					<p>{i18next.t('template_receive_screen_message_08')}...</p>
				)}
			</div> */}

			<div style={styles.qrContainer} ref={qrCodeRef}></div>
			
			{network.toLowerCase() === process.env.REACT_APP_TON_NETWORK_NAME?.toLowerCase() && (
				<div>
					<CustomText weight="medium" style={{ ...styles.addressLabel, color: theme.text_01 }}>
						<CircleAlert name="alert-circle" size={16} color={theme.text_07} style={{...styles.icon, marginBottom: -4}} />
						Since different wallets generate different TON addresses,
					</CustomText>
					<CustomText weight="medium" style={{ ...styles.addressLabel, color: theme.text_01, paddingLeft: 22 }}>
						TON assets may not be compatible across these wallets.
					</CustomText>
				</div>
			)}

			
			<div style={styles.cardContainer}>
				<CustomText style={styles.addressLabel}>
					{i18next.t('template_receive_screen_message_09')}
				</CustomText>
				<div style={styles.addressContainer}>
					<IbmPlexMonoText style={styles.address} onClick={() => setShowFullAddress(!showFullAddress)}>
						{displayedAddress}{' '}
						<ZoomIn color={theme.text_01} style={{ marginBottom: -3 }} size={18} />
					</IbmPlexMonoText>
				</div>

				{/* 클립보드 복사 버튼 */}
				<div style={{ ...styles.clipboardButton, ...styles.clipboardButtonText, borderColor: theme.primary_normal, color: theme.primary_normal }} onClick={() => { copyToClipboard() }}>
					<Copy size={15} />
					<div>{t('template_receive_screen_message_10')}</div>
				</div>

				{/* 공유 버튼 */}
				<CustomButton
					containerStyle={{ ...styles.buttonShare, backgroundColor: theme.primary_normal }}
					textStyle={styles.buttonTextShare}
					onPress={() => { shareAddress() }}
					text={i18next.t('template_receive_screen_message_11')}
					withBackground={true}
					backgroundColor={theme.background_08}
				/>

				<div style={styles.noticeContainer}>
					<div style={styles.noticeHeaderContainer}>
						<CircleAlert name="alert-circle" size={16} color={theme.text_07} style={styles.icon} />
						<CustomText weight="medium" style={{ ...styles.noticeHeader, color: theme.label_strong }}>
							{i18next.t('template_receive_screen_message_12')}
						</CustomText>
					</div>

					<div style={styles.bulletContainer}>
						<CustomText style={styles.noticeText}>
							<span style={styles.bulletPoint}>•</span>{i18next.t('template_receive_screen_message_13')}
						</CustomText>
					</div>

					<div style={styles.bulletContainer}>
						<CustomText style={styles.noticeText}>
							<span style={styles.bulletPoint}>•</span>{i18next.t('template_receive_screen_message_14')}
						</CustomText>
					</div>

					<div style={styles.bulletContainer}>
						<CustomText style={styles.noticeText}>
							<span style={styles.bulletPoint}>•</span>{i18next.t('template_receive_screen_message_15')}
						</CustomText>
					</div>
				</div>
			</div>
		</div>
		</>
	)
}

export default ReceiveScreen
